import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';

import Alert from '../Alert';

const UnstyledStyledDrawerAlert = styled(Alert)``;

const StyledDrawerAlert = (props: ComponentProps<typeof UnstyledStyledDrawerAlert>) => (
  <UnstyledStyledDrawerAlert
    mt={['sp_20', 'sp_24']}
    mb={['sp_0', 'sp_4', 'sp_8']}
    mx="sp_16"
    {...props}
  />
);

export default StyledDrawerAlert;
